"use strict";

import angular from "angular";

import template from "./help-item-custom-topics.component.html";
import "./themes/help-item-custom-topics.component.scss";
import "./themes/help-item-custom-topics-dark.component.scss";

class HelpItemCustomTopicsComponent {
    constructor() {}

    $onInit() {}

    $onDestroy() {}

    $onChanges(changes) {}
}

HelpItemCustomTopicsComponent.$inject = [];

const name = "helpItemCustomTopicsComponent";
const def = {
    bindings: {
        content: "<"
    },
    controller: HelpItemCustomTopicsComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
